import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';

export const McoDispTrendChart = ({ selectedPeriod, selectedPbms = [], selectedCtrts = [], /*selectedProgTypes = [],*/ isUnits }) => {

  const rsrc = useRsrc();
  const [data, setData] = useState()

  const [yLabel, setYLabel] = useState()

  useEffect(() => {
    let yLabel = 'Disputed';
    yLabel = yLabel + (isUnits ? ' Units' : ' Dollars')
    setYLabel(yLabel);
  }, [isUnits]);

  useEffect(() => {
    if (!selectedPeriod?.id) {
      return;
    }

    const pbmIds = selectedPbms.map(pbm => pbm.id);
    const ctrtIds = selectedCtrts.map(ctrt => ctrt.id);
    // const progTypes = selectedProgTypes;
    const reqParam = {
      periodId: selectedPeriod.id,
      pbmIds,
      ctrtIds,
      // progTypes,
      isUnits
    };

    rsrc.data('sc', 'MCO_DISP_TREND_CHART_DATA_PLUGIN', reqParam).then(data => {
      setData(data);
    });
  }, [selectedPeriod, selectedPbms, selectedCtrts, /*selectedProgTypes,*/ isUnits]);

  if (!data) return null;

  return (
    <>
      <CartesianChart data={data} yLabel={yLabel} legend={'top'} xLabel={'Invoice Period'} />
    </>
  );
};
